import socket from '@/services/socket.js'

export default {
  /**
   * Get all children in group.
   *
   * @param params
   * @param ids
   * 
   * @returns Promise
   */
  get(params, ids = []) {
    const action = '/children/get'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_ids: [...ids],
        time_zone_offset_in_minutes: -240,
        include: [...params]
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data.users)
      })
    })
  },

  /**
   * Update child by id.
   *
   * @param user_id
   * @param attributes
   * 
   * @returns Promise
   */
  update(user_id, attributes) {
    const action = '/user/update'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        body: {
          ...attributes
        },
        user_id
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Delete child profile.
   *
   * @param user_id
   * 
   * @returns Promise
   */
  delete(user_id) {
    const action = '/user/delete'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Update child settings by child id.
   *
   * @param user_id
   * @param attributes
   * 
   * @returns Promise
   */
  updateSettings(user_id, attributes) {
    const action = '/user/settings/update'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        settings: {
          ...attributes
        },
        user_id,
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Get child accumulated screen time for selected period.
   *
   * @param user_id
   * @param min_date
   * @param max_date
   * 
   * @returns Promise
   */
  getScreenTime({ user_id, min_date, max_date }) {
    const action = '/user/accumulated_screentime/get'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id,
        body: {
          min_date,
          max_date
        }
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data.accumulated_screen_time)
      })
    })
  },

  /**
   * Update child screentime limit for selected date.
   *
   * @param user_id
   * @param date
   * @param limit
   * 
   * @returns Promise
   */
  setScreenTimeLimit(user_id, { date, limit }) {
    const action = '/user/screen_time_override/set'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id,
        body: {
          screen_time_override_in_minutes: limit,
          screen_time_override_date: date
        }
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Get child device events.
   *
   * @param user_id
   * @param event_names
   * @param max_date
   * 
   * @returns Promise
   */
  getDeviceEvents(user_id, event_names, max_date = new Date()) {
    const action = '/device_event/get_by_user_id'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id,
        event_names,
        body: {
          max_date
        }
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data.device_events)
      })
    })
  },


  /**
   * Get child avatar URL.
   *
   * @param user_id
   * @param avatar_id
   * 
   * @returns Promise
   */
  getAvatarUrl(user_id, avatar_id) {
    let action = '/avatar/download_url'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        body: {
          user_id,
          avatar_id
        }
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data.data.avatar_download_url)
      })
    })
  },

  /**
   * Get child upload avatar URL.
   *
   * @param user_id
   * 
   * @returns Promise
   */
  getUploadAvatarUrl(user_id) {
    let action = '/avatar/upload_url'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        body: {
          user_id
        }
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }
  
        resolve(data.avatars[0].upload_url)
      })
    })
  },


  /**
   * Set child parental mode.
   *
   * @param user_id
   * @param mode_id
   * @param duration_in_minutes
   * 
   * @returns Promise
   */
  setChildParentalMode({ user_id, mode_id, duration_in_minutes }) {
    let action = '/user/parental_mode/add'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        body: {
          user_id,
          mode_id,
          duration_in_minutes
       }
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }
  
        resolve(data)
      })
    })
  },

  /**
   * Remove child parental mode.
   *
   * @param user_id
   * 
   * @returns Promise
   */
  removeChildParentalMode(user_id) {
    let action = '/user/parental_mode/delete'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }
  
        resolve(data)
      })
    })
  }
}